import { getDarkenColor, hexToRgbA } from ".";

export default (type, colors) => {
  const styles = {
    default: {
      'c-tabs--default__tab': {
        customCSS: `
          .c-tabs--default .c-tabs__tab {
            color: ${colors.primary};
          }
          .c-tabs--default .c-tabs__tab:hover,
          .c-tabs--default .c-tabs__tab:active,
          .c-tabs--default .c-tabs__tab:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
          }

          .c-tabs--default .c-tabs__tab.state-active {
            color: ${colors.secondary_dark};
          }

          .c-tabs--default .c-tabs__tab.state-active:hover,
          .c-tabs--default .c-tabs__tab.state-active:active,
          .c-tabs--default .c-tabs__tab.state-active:focus {
            color: ${getDarkenColor(colors.secondary_dark, 0.2)};
          }
        `
      },
      'c-tabs--pagey__tab': {
        customCSS: `
          .c-tabs--pagey .c-tabs__tab {
            color: ${colors.secondary_dark};
          }
          .c-tabs--pagey .c-tabs__tab {
            background: ${hexToRgbA(getDarkenColor(colors.light,0.026), 0.7)};
          }
          .c-tabs--pagey .c-tabs__tab:hover,
          .c-tabs--pagey .c-tabs__tab:active,
          .c-tabs--pagey .c-tabs__tab:focus {
            color: ${getDarkenColor(colors.secondary_dark, 0.2)};
          }
        `
      },
    },
    type1: {
      'c-tabs--default__tab': {
        customCSS: `
          .c-tabs--default .c-tabs__tab {
            color: ${colors.primary};
          }
          .c-tabs--default .c-tabs__tab:hover,
          .c-tabs--default .c-tabs__tab:active,
          .c-tabs--default .c-tabs__tab:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
          }

          .c-tabs--default .c-tabs__tab.state-active {
            color: ${colors.secondary_dark};
          }

          .c-tabs--default .c-tabs__tab.state-active:hover,
          .c-tabs--default .c-tabs__tab.state-active:active,
          .c-tabs--default .c-tabs__tab.state-active:focus {
            color: ${getDarkenColor(colors.secondary_dark, 0.2)};
          }
        `
      },
      'c-tabs--pagey__tab': {
        customCSS: `
          .c-tabs--pagey .c-tabs__tab {
            color: ${colors.secondary_dark};
          }
          .c-tabs--pagey .c-tabs__tab {
            background: ${hexToRgbA(getDarkenColor(colors.light,0.026), 0.7)};
          }
          .c-tabs--pagey .c-tabs__tab:hover,
          .c-tabs--pagey .c-tabs__tab:active,
          .c-tabs--pagey .c-tabs__tab:focus {
            color: ${getDarkenColor(colors.secondary_dark, 0.2)};
          }
        `
      },
      'c-tabs--pagey': {
        marginTop: 0
      },
      'c-tabs__tab': {
        fontSize: '24px',
        lineHeight: '126%',
        fontWeight: 'normal',
        marginLeft: '10px',
        marginRight: '10px',
        paddingBottom: '5px',
        paddingLeft: 0,
        paddingRight: 0,
        textTransform: 'uppercase',
        customCSS: `
          background: ${hexToRgbA(getDarkenColor(colors.light,0.026), 0.7)};
          .c-tabs__tab {
            color: ${colors.primary};
          }
          .c-tabs__tab:first-of-type {
            margin-left: 0!important;
          }
        `
      },
      'c-tabs__content': {
        fontSize: '16px',
        paddingLeft: '0',
        paddingRight: '0'
      },
      'c-tabs__tab__active': {
        color: colors.primary,
        backgroundColor: "white",
        borderBottom: '1px solid'
      },
      'c-tabs__tab__article': {
        fontWeight: 'bold',
        fontSize: '16px',
        padding: '5px 0',
        margin: '0 25px',
        color: '#C4C4C4',
      },
      'c-tabs__nav': {
        margin: '0 20px',
        customCSS: `
          .c-tabs__tab.state-active {
            color: ${colors.primary}!important;
            border-bottom: 1px solid!important;
          }
        `
      }
    }
  }

  return styles[type]
}



// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/cTabs.js